import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectPaymentFormPayload } from '@cashier/cashier-data-access';
import { ValidationStatuses } from '@cashier/cashier-model';

export const useErrorList = (): string[] => {
  const payload = useSelector(selectPaymentFormPayload);

  return useMemo(() => {
    const errors: string[] = [];

    Object.keys(payload || {}).forEach((fieldName) => {
      const fieldPayload = payload[fieldName];

      if (!fieldPayload) {
        return;
      }

      const {
        errors: payloadErrors,
        validationStatus,
        interactionCompleted,
      } = fieldPayload;

      if (
        interactionCompleted &&
        validationStatus === ValidationStatuses.FAILED &&
        payloadErrors
      ) {
        errors.push(...payloadErrors);
      }
    });

    return errors;
  }, [payload]);
};
